export default "__VITE_ASSET__DEgBBZEk__"